import { FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import * as Yup from 'yup';

/**
 * 贵宾休息室预约查询
 */
export interface SaInfo {
  /**
   * 页数
   */
  page?: number;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 会员号
   */
  user_code?: string;
  /**
   * 预约时间(start_date、end_date)
   */
  time_range?: string[];
}

/**
 * 导购大使详情
 */
export interface SaDetailInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 预约时间段
   */
  number?: string;
  /**
   * 预约人数
   */
  content?: string;
}

/**
 * 导购大使预约查询表单默认值
 */
export const defaultInfo: SaInfo = {
  page: 1,
  phone: '',
  user_code: '',
  time_range: [dayjs().format(FULL_DATE), dayjs().format(FULL_DATE)]
};

/**
 * 导购大使详情表单默认值
 */
export const defaultDetailInfo: SaDetailInfo = {
  remark: '',
  number: '',
  content: '',
};

/**
 * 免提购物详情表单校验
 */
export const saDetailSchema = Yup.object().shape(
  {
    // handsfree_items: Yup.array().of(
    //   Yup.object({
    //     brand: Yup.string().required('请选择品牌名'),
    //     num: Yup.string().ensure().required('请输入购物袋数量').matches(/^[1-9]\d*$/, '请输入正确的数量'),
    //   })
    // )
  }
)